import { api } from '@/lib/api'

/**
 * @returns {Promise<import('@/types/api').CommissionProfile[]>}
 */
export async function fetchCommissionProfiles() {
  const { data } = await api.get('/masters/commission-profiles')
  return data.data.commission_profiles
}

/**
 * @param {number} profileId
 * @returns {Promise<import('@/types/api').CommissionProfile>}
 */
export async function fetchCommissionProfile(profileId) {
  const { data } = await api.get(`/masters/commission-profiles/${profileId}`)
  return data.data.commission_profile
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<import('@/types/api').CommissionProfile>}
 */
export async function createCommissionProfile(payload) {
  const { data } = await api.post('/masters/commission-profiles', payload)
  return data.data.commission_profile
}

/**
 * @param {number} profileId
 * @param {Record<string, unknown>} payload
 * @returns {Promise<import('@/types/api').CommissionProfile>}
 */
export async function updateCommissionProfile(profileId, payload) {
  const { data } = await api.put(`/masters/commission-profiles/${profileId}`, payload)
  return data.data.commission_profile
}
